
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stars/[slug]",
      function () {
        return require("private-next-pages/stars/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stars/[slug]"])
      });
    }
  